/* R62 legal pages: "On this page" from the article's own H2 headings, and the current-section highlight.
   FAQs: aria-expanded on the existing question buttons.
   Without this script the page reads normally; the lists stay hidden. No motion. */
(() => {
  // FAQs: the theme toggles li.active on the question button; expose that state to screen readers.
  document.querySelectorAll('.r62-shell--help [data-block="content_tabs"] > li').forEach((li, i) => {
    const button = li.querySelector(':scope > button'), panel = li.querySelector(':scope > div');
    if (!button || !panel) return;
    panel.id = panel.id || 'r62-faq-' + (i + 1);
    button.setAttribute('aria-controls', panel.id);
    const sync = () => button.setAttribute('aria-expanded', li.classList.contains('active') ? 'true' : 'false');
    sync(); new MutationObserver(sync).observe(li, { attributes: true, attributeFilter: ['class'] });
  });

  const shell = document.querySelector('.r62-shell[data-r62-view="legal"]');
  if (!shell) return;
  const main = shell.querySelector('.r62-main');
  const heads = [...main.querySelectorAll('.rte h2')].filter(h => h.textContent.trim());
  if (heads.length < 3) return;

  const used = new Set([...document.querySelectorAll('[id]')].map(e => e.id));
  const slug = t => t.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
  heads.forEach(h => {
    if (h.id) return;
    let id = 'r62-' + slug(h.textContent.trim()), n = 2;
    while (used.has(id)) id = 'r62-' + slug(h.textContent.trim()) + '-' + n++;
    used.add(id); h.id = id;
  });

  const label = shell.dataset.r62TocLabel || 'On this page';
  const items = () => heads.map(h => {
    const li = document.createElement('li'), a = document.createElement('a');
    a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.append(a); return li;
  });

  // Desktop side column.
  const side = shell.querySelector('[data-r62-toc]');
  if (side) { side.querySelector('ol').append(...items()); side.hidden = false; }

  // Phones and tablets: a native disclosure right after the page title.
  const inline = document.createElement('details');
  inline.className = 'r62-toc-inline';
  const summary = document.createElement('summary'); summary.textContent = label;
  const list = document.createElement('ol'); list.setAttribute('role', 'list'); list.append(...items());
  inline.append(summary, list);
  const title = main.querySelector('h1');
  (title ? title.closest('.shopify-policy__title') || title : main.querySelector('.r62-eyebrow')).after(inline);
  inline.addEventListener('click', e => { if (e.target.closest('a')) inline.open = false; });

  // Mark the section being read in the side column.
  if (!side || !('IntersectionObserver' in window)) return;
  const links = new Map([...side.querySelectorAll('a')].map(a => [a.hash.slice(1), a]));
  let current = null;
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) current = e.target.id; });
    links.forEach((a, id) => id === current ? a.setAttribute('aria-current', 'location') : a.removeAttribute('aria-current'));
  }, { rootMargin: '-120px 0px -60% 0px' });
  heads.forEach(h => io.observe(h));
})();
